<div class="md-help">
  <p class="text-500 mt-0">
    Most of this is on the toolbar — select some text and press a button. The syntax
    below is what those buttons write, and what you will see in copy someone else wrote.
  </p>

  <h3>Formatting</h3>
  <table>
    <tr *ngFor="let r of formatting">
      <th>{{ r.what }}</th>
      <td><code>{{ r.how }}</code></td>
    </tr>
  </table>

  <h3>Colour</h3>
  <table>
    <tr *ngFor="let r of colour">
      <th>{{ r.what }}</th>
      <td>
        <code>{{ r.how }}</code>
        <small class="block text-500 mt-1">{{ r.note }}</small>
      </td>
    </tr>
  </table>
  <p class="text-500">
    The colours:
    <code *ngFor="let c of colourNames" class="mr-1">{{ c }}</code>
  </p>

  <h3>Alignment</h3>
  <table>
    <tr *ngFor="let r of align">
      <th>{{ r.what }}</th>
      <td><code>{{ r.how }}</code></td>
    </tr>
  </table>
  <p class="text-500">
    Alignment always applies to whole paragraphs. Unlike colour, it cannot be used on
    a few words — text alignment is a property of the paragraph, not the words in it.
  </p>

  <h3>Combining them</h3>
  <table>
    <tr *ngFor="let r of combining">
      <th>{{ r.what }}</th>
      <td>
        <code>{{ r.how }}</code>
        <small class="block text-500 mt-1">{{ r.note }}</small>
      </td>
    </tr>
  </table>

  <h3>Live values</h3>
  <p class="text-500 mt-0">
    Type <code>&#123;&#123;</code> and pick from the list — these pull the real figure at
    build time, so copy never drifts from the record it came from.
  </p>
  <table>
    <tr *ngFor="let r of tokens">
      <th>{{ r.what }}</th>
      <td><code>{{ r.how }}</code></td>
    </tr>
  </table>
  <p class="md-help-warn">
    A token that points at something that no longer exists <strong>stops the whole
    website from publishing</strong>, not just this page. Use the picker rather than
    typing one by hand, and check Preview before saving.
  </p>

  <h3>If a marker is wrong</h3>
  <p class="text-500 mt-0">
    It appears on the page as plain text — you will see <code>::: colour-ornage</code>
    rather than coloured words. That is deliberate: a visible typo is easier to find
    than silently missing colour. <strong>Preview</strong> shows exactly what publishes.
  </p>

  <div class="editor-footer mt-4">
    <button pButton pRipple type="button" label="Close" (click)="ref.close()"></button>
  </div>
</div>
